site.megamenu = {
	init:function() {
		var $mainmenu = $('#mainmenu');
		$('.mmLevel2', $mainmenu).wrap('<div class="megamenu"/>');
		$mainmenu.on('click', function(e) {
			e.stopPropagation();
		});

		site.megamenu.background();

		$('.level1.children > a',$mainmenu).on('click', function (e) {
			if ($(document).width()+15 >= 992 && !$('body').hasClass('stillingar')) {
				e.preventDefault();
				e.stopPropagation();

				//Click on node that is already open
				if ($(this).parent().hasClass('open')) {
					site.megamenu.close();
				}
				//Open megamenu
				else {
					$('body').addClass('megamenu-open');
					$('.level1.open', $mainmenu).removeClass('open');
					$('.megamenu', $mainmenu).removeAttr('style');
					$(this).parent().addClass('open');
					var $megamenu = $(this).parent().find('.megamenu'),
						$megamenuHeight = $megamenu[0].scrollHeight + 5,
						$viewportHeight = window.innerHeight,
						$maxAllowed = $viewportHeight - 175;

					var finalHeight = Math.min($megamenuHeight, $maxAllowed);

					$megamenu.css('max-height', finalHeight);
					$('#megamenuBg', $mainmenu).css('height', finalHeight);
					$('#pageContainer').css('min-height', finalHeight+142);


				}

				$('body.megamenu-open').on('click', function (e) {
					site.megamenu.close();
				});
			}
		});

		$('.level2.children > a span','.megamenu').unwrap();
	},

	close:function() {
		var $mainmenu = $('#mainmenu');
		$('.megamenu', $mainmenu).removeAttr('style');
		$('#megamenuBg', $mainmenu).removeAttr('style');
		$('.level1.open', $mainmenu).removeClass('open');
		$('#pageContainer').removeAttr('style');
		$('body').removeClass('megamenu-open');
	},

	background:function() {
		var $mainmenu = $('#mainmenu');
		$mainmenu.append('<div id="megamenuBg" />');
		$(window).resize(function() {
			if ($('body').hasClass('megamenu-open')) {
				var $megamenu = $('.open .megamenu', $mainmenu),
					$megamenuHeight = $megamenu[0].scrollHeight;
				$megamenu.css('max-height', $megamenuHeight);
				$('#megamenuBg', $mainmenu).css('height', $megamenuHeight);
				$('#pageContainer').css('min-height', $megamenuHeight+142);
			}
		});
	}
};
